import { render, staticRenderFns } from "./is-quiz-question.vue?vue&type=template&id=ab0027e4&scoped=true"
import script from "./is-quiz-question.vue?vue&type=script&lang=js"
export * from "./is-quiz-question.vue?vue&type=script&lang=js"
import style0 from "./is-quiz-question.vue?vue&type=style&index=0&id=ab0027e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0027e4",
  null
  
)

export default component.exports